import fetch from "../auth/FetchInterceptor";
import { env } from "../configs/EnvironmentConfig";

const EmailTemplateService = {};

EmailTemplateService.listEmailTemplate = ({ params }) => {
  // const columnFilter = params.columnFilter || {};

  return fetch({
    url: `${env.API_MSPCNM}/templates?filter[record_status]=O`,
    method: "get",
    // params: {
    //   ...columnFilter,
    //   page: params.page || 1,
    //   "per-page": params.sizePerPage || 10,
    //   sort: params.sort || "-checker_date",
    //   keywords: params.keywords || "",
    // },
  });
};

EmailTemplateService.detailsEmailTemplate = ({ emailTemplateId }) => {
  return fetch({
    url: `${env.API_MSPCNM}/templates/${emailTemplateId}`,
    method: "get"
  });
};

EmailTemplateService.createEmailTemplate = ({ emailTemplate }) => {
  return fetch({
    url: `${env.API_MSPCNM}/templates`,
    method: "post",
    data: {
      ...emailTemplate,
    },
  });
};

EmailTemplateService.updateEmailTemplate = ({ id, emailTemplate }) => {
  return fetch({
    url: `${env.API_MSPCNM}/templates/${id}`,
    method: "put",
    data: {
      ...emailTemplate
    }
  });
};

EmailTemplateService.deleteEmailTemplate = ({ emailTemplateId }) => {

  return fetch({
    url: `${env.API_MSPCNM}/templates/${emailTemplateId}`,
    method: "delete",
  });
};


export default EmailTemplateService;
